import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import MiniArea from '../../../components/chart/MiniArea';
var searchData = [];
for (var i = 0; i < 50; i++) {
  searchData.push({
    index: i + 1,
    keyword: '关键词-' + i,
    count: Math.floor(Math.random() * 1000),
    range: Math.floor(Math.random() * 100),
    status: Math.floor(Math.random() * 10 % 2)
  });
}
var columns = [{
  dataIndex: 'index',
  key: 'rank'
}, {
  dataIndex: 'keyword',
  key: 'keyword',
  scopedSlots: {
    customRender: 'keyword'
  }
}, {
  dataIndex: 'count',
  key: 'users',
  sorter: function sorter(a, b) {
    return a.count - b.count;
  }
}, {
  title: '周涨幅',
  dataIndex: 'range',
  key: 'range',
  scopedSlots: {
    customRender: 'rang'
  }
}];
export default {
  name: 'HotSearch',
  components: {
    MiniArea: MiniArea
  },
  i18n: require('./i18n-search'),
  data: function data() {
    return {
      searchData: searchData,
      columns: columns
    };
  },
  computed: {
    tableColumns: function tableColumns() {
      var _this = this;
      var columns = this.columns;
      return columns.map(function (item) {
        item.title = _this.$t(item.key);
        return item;
      });
    }
  }
};